import React, { useState } from 'react';
import _ from 'lodash'
import { navigate } from '@reach/router';
import styles from './BookSearchResult.module.scss';
import cx from 'classnames';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { Button, FormErrors } from '@squirrellearningltd/go-pupil-components';
import { X } from 'react-feather';
import { useMutation } from '@apollo/react-hooks';
import { STUDENT_ADD_READING_BOOK } from '../../../../services/graphql';
import { BOOK_TYPES } from '../../../../../../services/constants';
import BookItem from '../BookItem';
import BookDefaultCover from '../../../../../../components/BookDefaultCover';
import { MAIN_DASHBOARD_QUERY } from '../../../../../Dashboard/services/graphql';
import { useTranslation } from 'react-i18next';

const PublisherSearchResults = ({loadingMore, books, total, onFetchMore, setSearchOption, recommended = false}) => {
    
    const { t } = useTranslation();
    const [formErrors, setFormErrors] = useState([]);
    const [modalBookType, setModalBookType] = useState(null);

    const [studentAddReadingBook, { loading }] = useMutation(STUDENT_ADD_READING_BOOK, {
        update: (_, { data }) => {
            if (data.studentAddReadingBook.errors && data.studentAddReadingBook.errors.length !== 0) {
                setFormErrors(data.studentAddReadingBook.errors);
                return;
            } else if (data.studentAddReadingBook.studentReadingBook.id) {
                setModalBookType(null);
                navigate(`/book/${data.studentAddReadingBook.studentReadingBook.id}`);
            }
        },
        awaitRefetchQueries: true,
        refetchQueries: [{ query: MAIN_DASHBOARD_QUERY }]
    });

    const { register, handleSubmit, errors } = useForm({
        validationSchema: Yup.object().shape({
            bookType: Yup.number().typeError(t('select_book_type'))
        })
    });

    const onSubmit = ({ bookType })=> {
        studentAddReadingBook({
            variables: {
                bookId: modalBookType.book.id,
                bookType
            }
        })
    }


    return (
        <>
            {books.length > 0 ? (
                <>
                    <div className={cx(styles.resultsList, {[styles.resultsListRecommended]: recommended})}>
                        {_.map(books, book => {
                            return (
                                <div className={styles.bookResult} key={`book${book.id}`}>
                                    <div className={styles.bookResultCover}>
                                        <BookDefaultCover coverUrl={book.coverUrl} alt={book.title} />
                                    </div>
                                    <div className={styles.bookResultDetails}>
                                        <h2>{book.title}</h2>
                                        <p>{book.author}</p>
                                    </div>
                                    <button type="button" className={styles.bookResultButton} onClick={() => setModalBookType({ show: true, book: book })}>
                                        Add book
                                    </button>
                                </div>
                            );
                        })}
                    </div>
                    {/* {!recommended && <p>{t('showing_xx_of_total_books', {booksNumber: books.length, totalNumber: total})}</p>} */}
                    {!recommended && books.length < total && <Button outline fullWidth onClick={onFetchMore}>{loadingMore ? t('loading') : t('load_more')}</Button>}
                    {modalBookType && (
                        <div className={styles.bookSelectionModalOverlay}>
                            <div
                                aria-label={modalBookType.book.title}
                                aria-modal="true"
                                className={styles.bookSelectionModalDialog}
                                role="dialog"
                            >
                                <button
                                    aria-label="Close book selection"
                                    className={styles.bookSelectionModalClose}
                                    onClick={() => setModalBookType(null)}
                                    type="button"
                                >
                                    <X />
                                </button>
                                <div className={styles.bookSelection}>
                                    <div className={styles.bookSelectionCover}>
                                        <BookDefaultCover coverUrl={modalBookType.book.coverUrl} alt={modalBookType.book.title} />
                                    </div>
                                    <div className={styles.bookSelectionContent}>
                                        <BookItem book={modalBookType.book} showSelectBtn={false} modal />
                                        <form className={styles.bookSelectionForm} onSubmit={handleSubmit(onSubmit)}>
                                            <label htmlFor="book-selection-type">
                                                {t('what_type_of_reading_book_would_you_like_to_add')}
                                            </label>
                                            <select id="book-selection-type" ref={register} name="bookType" className="basic-form__text-select">
                                                {BOOK_TYPES.filter(bookType => bookType.type !== 4).map(bookType => (
                                                    <option key={bookType.type} value={bookType.type}>{t(bookType.extended_label)}</option>
                                                ))}
                                            </select>
                                            {errors.bookType && <p className="basic-form__hint">{errors.bookType.message}</p>}
                                            {formErrors.length !== 0 && <FormErrors errors={formErrors.map(error => t(error))} />}
                                            <Button className={styles.bookSelectionSubmit} type="submit" outline>
                                                {loading ? t('adding') : t('add_book')}
                                            </Button>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                )}
            </>
            ) : (
                !recommended && <>
                    <h2>{t('hmm_we_couldnt_find_book')}</h2>
                    <p>{t('did_you_spell_title_correctly')}</p>
                    <p>{t('done_all_that_add_book_to_db')}</p>
                    <Button outline onClick={setSearchOption}>{t('add_new_book')}</Button>
                </>
            )}
        </>
    )
}

export default PublisherSearchResults;
